import { useMemo } from "react";

export type WordCloudDataType = {
  text: string;
  value: number;
};

export const useWordsCount = (words: string[]) =>
  useMemo(() => words.reduce(
    (acc: WordCloudDataType[], word) => {

      for (const element of acc) {
        if (element.text === word) {
          element.value++;
          return acc;
        }
      }

      acc.push({ text: word, value: 1 });

      return acc;
    },
    [],
  ).filter(element =>
    element.value > 1
    && /(\D+)/.test(element.text)
    && /^(a|and|the|to|with|for|of|is|has|on|it|its|are|in|that|from|you|have|be|some|this|at|our|should|stock|stocks)$/i.test(element.text) === false), [words]);
